module.exports = __webpack_public_path__ + "img/undo.b35c0b6e.svg";